import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const cfg = { withCredentials: true };

export const getPermissionCatalog = () =>
  axios.get(`${API_BASE_URL}/api/permissions`, cfg).then((r) => r.data);
export const listRoles = () =>
  axios.get(`${API_BASE_URL}/api/roles`, cfg).then((r) => r.data);
export const getRole = (id) =>
  axios.get(`${API_BASE_URL}/api/roles/${id}`, cfg).then((r) => r.data);
export const createRole = (payload) =>
  axios.post(`${API_BASE_URL}/api/roles`, payload, cfg).then((r) => r.data);
export const updateRole = (id, payload) =>
  axios.put(`${API_BASE_URL}/api/roles/${id}`, payload, cfg).then((r) => r.data);
export const deleteRole = (id) =>
  axios.delete(`${API_BASE_URL}/api/roles/${id}`, cfg).then((r) => r.data);
export const assignRole = (userId, roleKey) =>
  axios.post(`${API_BASE_URL}/api/users/${userId}/roles`, { role_key: roleKey }, cfg).then((r) => r.data);
export const unassignRole = (userId, roleKey) =>
  axios.delete(`${API_BASE_URL}/api/users/${userId}/roles/${roleKey}`, cfg).then((r) => r.data);
